import { useDispatch, useSelector } from 'react-redux'
import Cookies from "universal-cookie";
import { BanknotesIcon, BellAlertIcon, PencilSquareIcon, CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/react/24/outline"
import { useState, useEffect, useCallback, useRef } from 'react'
import Chart from 'react-apexcharts'

import Container from "../components-layout/Container" // Container toda app
import Layout from "../Layout" // Layout toda app
import Header from "../components-layout/Header"
import WarningModal from '../components-modals/WarningModal.js'

import { fetchApi } from "../tools" // Consumir api
import { getDashboard, getPerfiles, setCta, setNotas, setNoti, setGraficaNotas } from '../../app/dashboardAlumnosSlice'

import InformacionAlumno from "./InformacionAlumno.js"
import CardsAlumno from "./CardsAlumnos.js"
import PagosRecientesAlumnos from './PagosRecientesAlumnos.js'
import ModalDeuda from '../modal-deuda/ModalDeuda';
import Circular from './circular/Circular.js';

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const chartOptions = {
    chart: {
        type: 'bar',
        height: 400,
        animations: {
            enabled: true,
            easing: 'easeinout',
            speed: 800,
            animateGradually: {
                enabled: true,
                delay: 150
            },
            dynamicAnimation: {
                enabled: true,
                speed: 350
            }
        }
    },
    responsive: [{
        breakpoint: 480,
        options: {
            legend: {
                position: 'bottom',
                offsetX: -10,
                offsetY: 0
            },
        }
    },
    ],
    plotOptions: {
        bar: {
            borderRadius: 10,
            horizontal: false,
            columnWidth: '70%',
            endingShape: 'rounded',
        },
    },
    stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
    },
    xaxis: {
        type: 'category',
        position: 'bottom',
        labels: {
            rotate: -45,
            style: {
                colors: Array(50).fill('#9197a1'),
                fontSize: '8px',
            }
        },
    },
    yaxis: {
        labels: {
            style: {
                colors: ['#9197a1'],
            },
            // formatter: (value) => {
            //     return Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(value)
            // },
        }
    },
    fill: {
        opacity: 1
    },
    colors: ['#4782da', '#2e4b76', '#9197a1', '#E68A00'],
    dataLabels: {
        enabled: false,
        style: {
            colors: ['#fff']
        },
        // formatter: (value) => {
        //     return Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(value)
        // },
    },
    legend: {
        position: 'right',
        offsetX: 0,
        offsetY: 50,
        show: true,
        labels: {
            colors: ['#fff']
        }
    },
    tooltip: {
        y: {
            // formatter: (value, { series, seriesIndex, dataPointIndex, w }) => {
            //     return Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(value)
            // }
        }
    },
    grid: {
        show: false,
    },
}

const dataFormatter = (objArray = []) => {

    let arr = []

    arr.push({
        name: '1er. Bimestre',
        data: Object.values(objArray.filter(u => u.Unidad === 1)).map(n => {
            return n.Total
        })
    })

    arr.push({
        name: '2do. Bimestre',
        data: Object.values(objArray.filter(u => u.Unidad === 2)).map(n => {
            return n.Total
        })
    })

    arr.push({
        name: '3er. Bimestre',
        data: Object.values(objArray.filter(u => u.Unidad === 3)).map(n => {
            return n.Total
        })
    })

    arr.push({
        name: '4to. Bimestre',
        data: Object.values(objArray.filter(u => u.Unidad === 4)).map(n => {
            return n.Total
        })
    })

    return arr
}

const dataFormatterCategoria = (objArray = []) => {
    let arr = []

    Object.values(objArray.filter(u => u.Unidad === 1)).map(n => {
        // arr.push(n.Materia)
        let toca = 0
        let mat = ''
        let mat1 = ''
        let mat2 = ''
        for (var i = 0; i <= n?.Materia?.length; i++) {
            if (n.Materia.charAt(i) === ' ') {
                toca++
                if (toca < 3) {
                    if (toca >= 1) {
                        mat1 = mat1 + n?.Materia.charAt(i)
                    } else {
                        mat = mat + n?.Materia.charAt(i)
                    }
                } else {
                    mat2 = mat2 + n?.Materia.charAt(i)
                }
            } else {
                if (toca < 3) {
                    if (toca >= 1) {
                        mat1 = mat1 + n?.Materia.charAt(i)
                    } else {
                        mat = mat + n?.Materia.charAt(i)
                    }
                } else {
                    mat2 = mat2 + n?.Materia.charAt(i)
                }
            }
        }
        if (mat1 !== '') {
            mat = mat.trim()
            mat1 = mat1.trim()
            mat2 = mat2.trim()
            arr.push([mat, mat1, mat2])
        } else {
            arr.push(n?.Materia)
        }
    })

    return arr
}

const DashboardAlumnos = () => {

    const [deudaOpen, setDeudaOpen] = useState(true)
    const [circularOpen, setCircularOpen] = useState(false)
    const circular = useSelector(state => state.dashboardAlumno?.dataPerfil[0]?.Circular)
    const [clickCircular, setClickCircular] = useState(0)
    const dispatch = useDispatch()

    const user = useSelector(state => state.auth.user)
    const Carnet = useSelector(state => state.auth.Carnet)
    const IdEmp = useSelector(state => state.auth.IdEmp)

    const status = useSelector((state) => state.dashboardAlumno.ApiResponse)

    const userObj = JSON.parse(user)

    userObj.LoginId = userObj.LoginId.split(' ').map(x => {
        return x.charAt(0).toUpperCase() + x.slice(1).toLowerCase()
    }).join(' ')

    const cookies = new Cookies()
    const url = cookies.get('__urlSchoolApi') // url para enviar al api viene de cookies
    const { headersAPI: headers } = useSelector(state => state.url) // Headers para enviar al api viene de redux

    const [loading, setLoading] = useState(false)

    //Manejo de errores
    const [modal, setModal] = useState({
        show: false,
        msg: '',
        ok: false,
    })

    const configObj = {
        url: url + '/perfilalumno/dashboard',
        headers,
        content: {
            Carnet,
            IdFamilia: IdEmp
        }
    }

    const configObjPerfiles = {
        url: url + '/perfilalumno/perfilesfamilia',
        headers,
        content: {
            IdFamilia: IdEmp
        }
    }

    const fetchDataCta = async () => {
        console.log('ejecutando fetch data')
        try {
            setLoading(true)
            const data = await fetchApi({
                url: url + '/perfilalumno/perfildeuda',
                headers,
                content: {
                    Carnet
                }
            })
            dispatch(setCta({ data }))

            const dataNotas = await fetchApi({
                url: url + '/reportes/cardnotas',
                headers,
                content: {
                    Carnet
                }
            })

            const dNotas = dataNotas.msg[0]
            dispatch(setNotas({ dNotas }))

            const dataGNotas = await fetchApi({
                url: url + '/reportes/graficanotas',
                headers,
                content: {
                    Carnet
                }
            })

            const dgNotas = dataGNotas.msg
            dispatch(setGraficaNotas({ dgNotas }))

            const dataNoti = await fetchApi({
                url: url + '/utils/notificaciones',
                headers,
                content: {
                    Carnet
                }
            })
            const dNoti = dataNoti.msg
            dispatch(setNoti({ dNoti }))

            setLoading(false)

            const modalDeuda = JSON.parse(localStorage.getItem('showModalDeuda'))
            if (modalDeuda) {
                setShowDeuda(false)
            } else {
                localStorage.setItem('showModalDeuda', JSON.stringify(true))
                setShowDeuda(true)
            }
        } catch (err) {
            console.log(err)
        }
    }

    const [showDeuda, setShowDeuda] = useState(false)
    const [contador, setContador] = useState(0)

    useEffect(() => {
        dispatch(getDashboard(configObj))
        dispatch(getPerfiles(configObjPerfiles))
        fetchDataCta()
        handleScroll(topRef.current) // en este caso se guia al usuario hasta arriba
        /*
        if(!circular){
            setCircularOpen(() => false)
        }*/
    }, [])

    const rawData = useSelector((state) => state.dashboardAlumno.data)
    const rawDataCta = useSelector((state) => state.dashboardAlumno.dataCta)
    const rawDataPerfiles = useSelector((state) => state.dashboardAlumno.dataPerfil)
    const rawDataNotas = useSelector((state) => state.dashboardAlumno.dataNotas)
    const rawDataNoti = useSelector((state) => state.dashboardAlumno.dataNoti)
    const rawDataGNotas = useSelector((state) => state.dashboardAlumno.dataGNotas)
    chartOptions.xaxis.categories = rawDataGNotas?.length > 0 ? dataFormatterCategoria(rawDataGNotas) : [];

    const topRef = useRef([])

    const handleScroll = (ref) => {
        window.scrollTo({
            top: ref.offsetTop,
            left: 0,
            behavior: "smooth",
        });
    }

    const moverIni = () => {
        handleScroll(topRef.current) // en este caso se guia al usuario hasta arriba
    }

    handleScroll(topRef.current) // en este caso se guia al usuario hasta arriba

    return (
        <div ref={topRef}>
            <WarningModal
                open={(status !== 'succeed' || loading) ? true : false}
                image={<img src='./img/loader.gif' alt='loading' />}
                opacity='bg-opacity-100'
            />
            <WarningModal
                open={modal.show ? true : false}
                image={
                    modal.ok
                        ? <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
                        : <ExclamationCircleIcon className="h-20 w-20 text-secundario mx-auto" />
                }
                title='Aviso'
                subtitle={<span>{modal.msg}</span>}
                opacity='bg-opacity-50'
            >
                <div className="mt-5 sm:mt-6">
                    <button
                        onClick={() => {
                            if (modal.reload) {
                                window.location.reload()
                            }
                            setModal(curr => ({
                                ...curr, show: false, reload: false
                            }))
                        }}
                        type="button"
                        className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
                    >
                        Entendido
                    </button>
                </div>
            </WarningModal>
            <Layout userObj={userObj} activeTab='Dashboard'>
                <Container height='h-full' >
                    <Header
                        title={`Dashboard ${rawDataPerfiles[0]?.Familia}`}
                    />
                    {/* Info. Alumno */}
                    {/* <div className='sticky top-0 z-30'> */}
                    {/* espacio para el modal deuda */}


                    <InformacionAlumno
                        datos={rawData}
                        moverIni={moverIni}
                    />
                    { circular && <Circular source={circular} setCircularOpen={setCircularOpen} setClickCircular={setClickCircular} circular={circular} circularOpen={circularOpen}/>}

                    {!circularOpen &&
                      rawDataCta.deuda && showDeuda ? 
                        <ModalDeuda data={rawDataCta} deuda={rawDataCta.deuda} deudaOpen={deudaOpen}
                          children={<div className="mt-5 sm:mt-6">
                         <button
                            onClick={() =>
                            setDeudaOpen(false)}
                            type="button"
                            className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
                         >
                         Entendido
                         </button>
                         </div>}
                         /> : null
                    }                    
                    
                    <div className="mt-4 bg-primarioMira rounded-2xl shadow-sm shadow-white">
                        <div className="mx-auto max-w-2xl lg:mx-0 lg:max-w-none">
                            <ul role="list" className={classNames(rawDataCta.deuda === 0 && rawDataCta.BlokNotas === false ? 'lg:grid-cols-3' : 'lg:grid-cols-2', 'px-4 py-4 mt-6 grid grid-cols-1 gap-x-6 gap-y-8 xl:gap-x-8')}>
                                <CardsAlumno
                                    id={1}
                                    name={'Estado de Cuenta'}
                                    imageUrl={BanknotesIcon}
                                    descrip={`Pago al día de hoy`}
                                    detail={rawDataCta.Hoy}
                                    descrip2={rawDataCta.hasta !== rawDataCta.desde ? `Pago de ${rawDataCta.desde} - ${rawDataCta.hasta}` : `Pago de ${rawDataCta.desde}`}
                                    detail2={Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format((rawDataCta.deuda > 0 ? rawDataCta.deuda : rawDataCta.ProximoPago))}
                                    vermas={1}
                                    path={'estadoCuenta'}
                                    color={rawDataCta.deuda > 0 ? true : false}
                                />
                                {rawDataCta.deuda === 0 && rawDataCta.BlokNotas === false &&
                                    <CardsAlumno
                                        id={1}
                                        name={'Notas'}
                                        imageUrl={PencilSquareIcon}
                                        descrip={`${rawDataNotas.Bimestre}`}
                                        detail={`Promedio ${rawDataNotas.Promedio}`}
                                        descrip2={`Materia ${rawDataNotas.Materia}`}
                                        detail2={`Nota ${rawDataNotas.Nota}`}
                                        vermas={1}
                                        path={'notas'}
                                    />
                                }
                                <CardsAlumno
                                    id={1}
                                    name={'Notificaciones'}
                                    imageUrl={BellAlertIcon}
                                    descrip={rawDataNoti?.length > 0 ? rawDataNoti[0]?.Titulo : ''}
                                    detail={rawDataNoti?.length > 0 ? rawDataNoti[0]?.FecDif : ''}
                                    detail2={<span className='text-xs line-clamp-3 text-justify'>{rawDataNoti?.length > 0 ? rawDataNoti[0]?.Descripcion : ''}</span>}
                                    vermas={0}
                                />
                            </ul>
                        </div>
                    </div>
                    <div className={classNames(rawDataCta.deuda === 0 && rawDataCta.BlokNotas === false ? 'lg:grid-cols-2' : 'lg:grid-cols-1', 'max-h-full px-6 py-6 grid grid-cols-1 gap-x-6 gap-y-8 xl:gap-x-8')}>
                        {/* Grid pagos recientes */}
                        <PagosRecientesAlumnos
                            datos={rawDataCta}
                            title='Pagos recientes'
                        />
                        {rawDataCta.deuda === 0 && rawDataCta.BlokNotas === false &&
                            <div className="space-y-16 py-2 xl:space-y-20 bg-primarioMira rounded-md shadow-md shadow-primarioMira">
                                {/* Grafica */}

                                <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                                    <h2 className="mx-auto max-w-2xl text-lg font-semibold leading-6 text-white lg:mx-0 lg:max-w-none">
                                        Rendimiento académico
                                    </h2>
                                </div>
                                {rawDataGNotas?.length > 0 &&
                                    <Chart
                                        options={chartOptions}
                                        series={dataFormatter(rawDataGNotas)}
                                        height='330px'
                                        type="bar"
                                    />
                                }
                            </div>
                        }
                    </div>
                </Container>
            </Layout>
        </div>
    )
}

export default DashboardAlumnos